/**
 * This handles any special form element handling.
 * Date Pickers,
 */

const noty = require('noty');
P3Portal.toggleOverlay = function () {
    $('.overlay-bg').toggleClass('hide');
    if ($('.overlay-bg').hasClass('hide')) {
        P3Portal.hideOverlay();
    }
};
P3Portal.showOverlay = function (html) {
    $('.overlay-container').removeClass('hide');
    $('.overlay-bg').removeClass('hide');
    $('.overlay-container').html(html);
};
P3Portal.hideOverlay = function () {
    $('.overlay-container').addClass('hide');
    $('.overlay-bg').addClass('hide');
};

P3Portal.user = {
    sitechange: function (selectrole, selectsite, initial) {
        role = selectrole.val();
        $('#select-salesrep_index').hide();
        $('select #select-salesrep_index').attr('required', false);
        if (role == 'enterprise_admin') {
            //selectsite.val('admin');
            selectsite.find('.optsite-admin').removeAttr('disabled');
            //P3Portal.messages.info('Enterprise Administrators will always log into the admin site');
        } else if (role == 'enterprise_user') {
            selectsite.find('.optsite-admin').removeAttr('disabled');
        } else if (role == 'customer_manager' || role == 'customer_service' || role == 'customer_user') {
            if (initial) {
                var val = selectsite.find('.defsite-1').attr('value');
                selectsite.val(val);
                selectsite.find('.optsite-admin').attr('disabled', 'disabled');
                P3Portal.messages.info('Please choose a customer site for this customer.');
            }
        } else if (role == 'salesrep') {
            $('#select-salesrep_index').show();
            $('select #select-salesrep_index').attr('required', true);
        }
        if (initial) {
            selectsite.select2('destroy');
            selectsite.select2({ width: '220px' });
        }
    },
};

P3Portal.Fields = {
    LeaveForm: function () {
        var saving = false;
        // When a user leaves a form without saving, throw an error
        if ($('form.leave-confirm').length > 0) {
            // bind something to the submit handler
            $('form.leave-confirm button[type="submit"]').click(function () {
                saving = true;
            });
            window.addEventListener('beforeunload', function (event) {
                if (!saving) {
                    var dialogText = 'Your work has not been saved. Do you want to leave this page?';
                    event.returnValue = dialogText;
                    return dialogText;
                }
            });
        }
    },

    ToggleFieldHelp: function () {
        var toggle = $('.toggle-field-help');
        if (toggle.length > 0) {
            var action = $('.help-toggle', toggle);
            action.click(function () {
                $('.help', toggle).toggle();
            });
        }
    },

    SpecValidate: function () {
        var selectrole = $('#select-userrole select');
        if (selectrole.length > 0) {
            var selectsite = $('#usersite select'),
                role = selectrole.val(),
                site = selectsite.val();
            P3Portal.user.sitechange(selectrole, selectsite);

            selectrole.change(function () {
                P3Portal.user.sitechange(selectrole, selectsite, true);
            });
        }
    },

    UserRoleEdit: function () {
        var selectrole = $('#select-userrole select');
        if (selectrole.length > 0) {
            var selectsite = $('#usersite select'),
                role = selectrole.val(),
                site = selectsite.val();
            P3Portal.user.sitechange(selectrole, selectsite);

            selectrole.change(function () {
                P3Portal.user.sitechange(selectrole, selectsite, true);
            });
        }
    },
    TabBind: function () {
        var tabwrapper = $('.tabwrapper');
        var initial_val = $('#customer_results input:checked').val();
        $.subscribe('customer-select-change', function (event, val) {
            initial_val = val;
        });
        $('.radio-col input').click(function () {
            initial_val = $(this).val();
        });
        if ($('.tab-body .tab.force-active').length > 0) {
            $('.tab-body .tab').hide();
            $('.tab-body .tab.force-active').show();
        }

        if (tabwrapper.length > 0) {
            $('.tabs li', tabwrapper).click(function (e) {
                $('.tabs li', tabwrapper).removeClass('active');

                var tabid = $(this).attr('data-tab');
                if (tabid == 'contact_newcustomer') {
                    $('#customer_select_new').prop('checked', 'checked');
                } else {
                    $('.customer_search input').prop('checked', false);
                    $('#customer_select_' + initial_val).prop('checked', 'checked');
                }
                $(this).addClass('active');
                $('input', $(this)).prop('checked', true);
                $('.tab', tabwrapper).hide();
                $('#' + tabid, tabwrapper).show();
            });
        }
    },

    MobileTable: function () {
        var width = $(window).width();
        if (width < 551) {
            // get each thead
            $('table').each(function (i, el) {
                var labels = [],
                    length = 0,
                    v = 0;
                $('th', $(this)).each(function (t, th) {
                    labels.push($(this).text());
                });
                length = labels.length;
                $('tbody tr', $(this)).each(function (n, tr) {
                    for (v; v < length; v++) {
                        if (labels[v] != '')
                            $('td', $(this))
                                .eq(v)
                                .prepend('<label>' + labels[v] + ': </label>');
                    }
                    v = 0;
                });
            });
        }
    },

    // Create a editable unique uri from a text field
    // and make it editable
    UniqueUri: function () {
        var el = $('.unique-uri'),
            edit = false;
        if (el.length > 0) {
            //var
            var manual = false;
            var change = function (e) {
                if (!manual) {
                    var val = $(this).val();
                    val = val
                        .replace(/[^a-zA-Z0-9] /g, '')
                        .replace(/\W+/g, '_')
                        .toLowerCase();
                    $('#uri').val(val);
                    $('#uri-text .text').text(val);
                }
            };
            $('#name', el).keyup(change);
            $('#name', el).change(change);
            $('.edit-uri').click(function () {
                $('#uri').removeClass('hide');
                $('#uri-text').hide();
                $(this).hide();
                manual = true;
            });
        }
    },
    ContactValidation: function () {
        if (P3Portal.ContactField) {
            console.log('In the ContactValidation function');
            if (P3Portal.ContactField.user) {
                console.log('In ContactValidation is .user');
                $('#specform').on('submit', function (e) {
                    //if the duplicate email error is turned on when they hit submit,
                    //stop the submit process and clear the form.
                    var testul = document.getElementById('emailErrorText');
                    if (testul != null) {
                        console.log('newcust-error-container HAS A VALUE IN IT');
                        //clear the form
                        $('input[name="customer_email"]').val('');
                        $('input[name="customer_name"]').val('');
                        $('input[name="customer_company"]').val('');
                        $('input[name="customer_phone"]').val('');
                        $('input[name="customer_address"]').val('');
                        $('input[name="customer_city"]').val('');
                        $('input[name="customer_state"]').val('');
                        $('input[name="customer_zip"]').val('');
                        var ul = document.getElementById('newcust-error-container');
                        if (ul.innerHTML !== '') {
                            ul.innerHTML = '';
                            ul.style.display = 'none';
                        }
                        e.preventDefault();
                        return false;
                    }

                    var checked = $('input[name="customer_select"]:checked').val(),
                        email = $('input[name="customer_email"]').val(),
                        chosen = $('.contact_choose:checked').val();
                    console.log(chosen);
                    if (P3Portal.ContactField.user == 'admin') {
                        if (
                            chosen != 'default' &&
                            chosen != 'current' &&
                            chosen != 'user' &&
                            (!checked || checked == 'new') &&
                            !email
                        ) {
                            new Noty({
                                theme: 'light',
                                layout: 'top',
                                type: 'warning',
                                text: 'You must either enter a customer or select a customer.',
                                timeout: 5000,
                            }).show();
                            e.preventDefault();
                            return false;
                        }
                    } else if (P3Portal.ContactField.user == 'guest') {
                        if (!email) {
                            new Noty({
                                theme: 'light',
                                layout: 'top',
                                type: 'warning',
                                text: 'You must either enter a customer or select a customer.',
                                timeout: 5000,
                            }).show();
                            e.preventDefault();
                            return false;
                        }
                    }
                    return true;
                });
            } else {
                console.log('In ContactValidation is NOT .user');
            }
        }
        $('#newcust_email').parsley();
        window.Parsley.addValidator('testemail', {
            validateString: function (value) {
                console.log('Entering newcust_email, value is' + JSON.stringify(value));
                return $.ajax({
                    url: '/api/testemail',
                    method: 'POST',
                    data: { newcust_email: value },
                    dataType: 'json',
                }).done(function (response) {
                    if ($.trim(response) === 'true') {
                        var ul = document.getElementById('newcust-error-container');
                        console.log('in newcust_email process');
                        if (ul.innerHTML !== '') {
                            ul.innerHTML = '';
                        }
                        ul.style.display = 'block';
                        var li = document.createElement('li');
                        li.id = 'emailErrorText';
                        var str1 = '<b>' + value + '</b>, is already in use in this enterprise.',
                            str2 = 'Please use the Customer search panel to find the Customer instead.';
                        li.insertAdjacentHTML('beforeend', str1 + '<br>' + str2);
                        ul.appendChild(li);
                        ul.style = 'list-style-type: none; color: red;';
                        return true;
                    } else {
                        var ul = document.getElementById('newcust-error-container');
                        if (ul.innerHTML !== '') {
                            ul.innerHTML = '';
                            ul.style.display = 'none';
                        }
                        return false; //email is new and okay to use.
                    }
                });
            },
        });
    },

    // Do the customer search lookup.
    SalesRep: function () {
        $('#sales_reps tr').click(function () {
            $('#sales_reps .radio-col input').prop('checked', false);
            $('#sales_reps tr.selected').removeClass('selected');
            $('input', $(this)).prop('checked', true);
            $(this).addClass('selected');
        });
        $('#sales_reps tr').each(function () {
            $('input', $(this));
        });

        $('#refresh-reps').click(function (e) {
            e.preventDefault();
            $(this).html('<i class="fa fa-spinner fa-spin"></i> Loading ...');
            $.get('/api/salesrep', function (data) {
                $.each(data, function (i, select) {
                    if ($('#rep-select').find("option[value='" + select.id + "']").length === 0) {
                        var newOption = new Option(select.index, select.id, false, false);
                        $('#rep-select').append(newOption).trigger('change');
                    }
                });
                $('#refresh-reps').html('<i class="fa fa-check"></i> Success');
                //
            });
        });
    },

    // Do the customer search lookup.
    CustomerSearch: function () {
        var views = [],
            customerList = [];

        // Get customer list from storage
        if ($('.customer_search').length == 1) {
            if (P3Portal.recentCustomers) {
                $('#customer_results tbody').append('<tr><td colspan=5><strong>Recent Search Results</td></tr>');
                $.each(P3Portal.recentCustomers, function (index, data) {
                    var view = new P3Portal.views.customer_row(data);
                    view.setElement('<tr />');
                    view.render();
                    views.push(view);
                });
                var oldCust = $('#old_customer_select');
                if (oldCust.length > 0) {
                    $('#customer_select_' + oldCust.val()).attr('checked', true);
                }
                $('td.radio-col input').click(function () {
                    var email = $(this).attr('data-email');
                    if (email === '') {
                        $('#select_email input').attr('required', true).focus();
                        $('#select_email').removeClass('hide');
                        new Noty({
                            theme: 'light',
                            layout: 'top',
                            type: 'warning',
                            text: 'The customer you selected does not have an email address. Please provide one in the field at the bottom.',
                            timeout: 4000,
                        }).show();
                        $('html,body').animate(
                            {
                                scrollTop: $('#select_email').offset().top,
                            },
                            'fast'
                        );
                    } else {
                        $('#select_email input').attr('required', false);
                        $('#select_email').addClass('hide');
                    }
                });
            }

            $('#customer_search').click(function (e) {
                e.preventDefault();
                var val = $('#customer_search_value').val();
                if (val === '') {
                    new Noty({
                        theme: 'light',
                        layout: 'top',
                        type: 'warning',
                        text: 'Please enter a value in the search field',
                        timeout: 4000,
                    }).show();
                    return false;
                }
                var search = {
                    type: $('#customer_search_type').val(),
                    search: val,
                };
                $('#customer_results tbody').html(
                    '<tr><td colspan=4><i class="fa fa-spinner fa-spin"></i> Searching ...</td></tr>'
                );
                $.post(
                    '/api/customer',
                    search,
                    function (data) {
                        $('#customer_results tbody').empty();
                        if (data.length > 0) {
                            var c = 0;
                            $.each(data, function (i, row) {
                                var view = new P3Portal.views.customer_row(row);
                                view.setElement('<tr />');
                                view.render();
                                views.push(view);
                                c++;
                                if (c > 98) {
                                    new Noty({
                                        theme: 'light',
                                        layout: 'top',
                                        type: 'warning',
                                        text: 'More than 100 results returned returned for that search.  You may want to narrow your search results.  We have only shown the first 100 below.',
                                        timeout: 4000,
                                    }).show();
                                    $('#customer_results tbody').append(
                                        "<tr><td colspan=4>There are more than 100 results for you request.  If you don't see the customer listed above, please narrow your search results.</td></tr>"
                                    );
                                    return false;
                                }
                            });
                        } else {
                            $('#customer_results tbody').html('<tr><td colspan=4>No results found.</td></tr>');
                        }
                        $('td.radio-col input').click(function () {
                            console.log($(this).val());

                            var email = $(this).attr('data-email');
                            if (email === '') {
                                $('#select_email input').attr('required', true).focus();
                                $('#select_email').removeClass('hide');
                                new Noty({
                                    theme: 'light',
                                    layout: 'top',
                                    type: 'warning',
                                    text: 'The customer you selected does not have an email address. Please provide one in the field at the bottom.',
                                    timeout: 4000,
                                }).show();
                                $('html,body').animate(
                                    {
                                        scrollTop: $('#select_email').offset().top,
                                    },
                                    'fast'
                                );
                            } else {
                                $('#select_email input').attr('required', false);
                                $('#select_email').addClass('hide');
                            }
                        });
                    },
                    'json'
                );
            });
        }
    },

    // Add the date picker control
    OverlayClick: function () {
        $('.overlay-bg').click(function () {
            P3Portal.hideOverlay();
            P3Portal.Events.trigger('overlay.click', {});
        });
    },
    DatePicker: function () {
        $('.datepicker input').datepicker({
            dateFormat: $('.datepicker').attr('date-format'),
        });
    },
    DatetimePicker: function () {
        $('.datetimepicker input').datetimepicker({
            dateFormat: $('.datetimepicker').attr('date-format'),
            timeFormat: 'hh:mm tt',
            defaultValue: '12:00 pm',
        });
    },
    // Add the chosen control
    Select2: function () {
        $('.chosen select').select2({
            minimumResultsForSearch: -1,
            width: '220px',
        });

        $('.user-management #content-filters .chosen select').select2({
            minimumResultsForSearch: -1,
            width: '10px',
        });

        $('#specform').parsley();
        window.Parsley.addValidator('conditionalvalue', function(value,requirements) {
          if (requirements[1] == $(requirements[0]).val() && '' == value)
            return false;
          return true;
        }, 32)
        .addMessage('en', 'conditionalvalue', 'You have to insert some value');
    },
    // Build the file control so that file buttons trigger the upload
    // handler
    FileBehavior: function () {
        // For each file control bind this as parent
        if ($('.file-control').length > 0) {
            $('.file-control').each(function (el, i) {
                var files = [];
                var single = true;
                var required = false;
                // This is the wrapper to confine scope
                var parent = $(this);
                if (parent.hasClass('multifileupload')) {
                    single = false;
                }
                if (parent.hasClass('required')) {
                    required = true;
                }

                //make sure our help text doesn't get pushed away by the file list to come.
                var help_text = this.getElementsByClassName('help');
                if (help_text.length > 0) {
                    help_text[0].style['width'] = '75%';
                    help_text[0].style['float'] = 'left';
                    help_text[0].style['height'] = '40px';

                    var button_el = this.getElementsByClassName('filetrigger');
                    button_el[0].style['float'] = 'left';
                    $(help_text).detach().insertAfter(button_el);
                }

                // Should be a list element for showing file names that we'll append to
                var listelement = $('.file-list', parent);
                var fieldelement = $('.fields', parent);
                // Fetch the name of the element
                var name = parent.attr('name');
                if (!single) {
                    name = name + '[]';
                }
                $('form.validate').on('submit', function () {
                    if (required && $('.file-list li', parent).length === 0) {
                        $('#max_file_error').remove();
                        var trigger_message = $(
                            '<div id="max_file_error" style="color: red">This field is required. You must upload at least one file</div>',
                            parent
                        );
                        $('.filetrigger', parent).after(trigger_message);
                        return false;
                    }
                });
                $('.filetrigger', parent).click(function (e) {
                    e.preventDefault();

                    var trigger = $(this);

                    //test to see if clicking this trigger will exceed the total number of files we can upload.
                    //counter for max file upload monitor
                    
                    var max_file_limit_hit = false;
                    var total_upload_files = 0;
                    console.log('init total_upload_files to ' + total_upload_files);
                    //test to see if we just hit max uploads by counting all LI elements in the file-list ULs including the one we just inserted.
                    var file_list_count = document.getElementsByClassName('file-list');
                    console.log('file_list_count reveals [' + file_list_count + '] elements with file-list class');
                    for (let i = 0; i < file_list_count.length; i++) {
                        total_upload_files += file_list_count[i].getElementsByTagName('li').length;
                        console.log('counted [' + total_upload_files + '] LI tags on this pass:[i]');
                    }

                    if (total_upload_files > 19) {
                        //while testing the limit will be three files to save me pain.
                        //if(total_upload_files > 2) {
                        $(function () {
                            var trigger_message = $(
                                '<div id="max_file_error" style="color: red">Limit reached: 20 Files</div>',
                                parent
                            );
                            trigger.after(trigger_message);
                            $('#dialog').dialog();
                            trigger.hide();
                            max_file_limit_hit = true;
                        });
                    }

                    if (!max_file_limit_hit) {
                        var control = $('<input type="file" name="' + name + '" class="hide" />');
                        control.attr('id', 'upload-' + Math.floor(Math.random() * 1000));
                        if (single) {
                            control = $('input[type="file"]', parent);
                            control.unbind('change');
                        } else {
                            fieldelement.append(control);
                        }

                        control.change(function (e) {
                            if (control[0].files.length == 1) {
                                var file = control[0].files[0];
                                var data = {
                                    id: control.attr('id'),
                                    name: file.name,
                                    $parent: listelement,
                                    onRemove: function () {
                                        console.log('removing');
                                        control.remove();
                                        if (single) trigger.show();
                                    },
                                };
                                var view = new P3Portal.views.fileupload_row(data);
                                view.setElement('<li class="row" />');
                                view.render();

                                if (single) trigger.hide();
                            } else {
                                control.remove();
                            }
                        });
                        control.click();
                    }
                });
            });

            $('.remove-file').click(function () {
                var whichrow = $(this).attr('data-count');
                $(this).prev().remove();
                $(this).remove();
                $(this).parent().hide();
                $('.filetrigger', parent).show().removeClass('hide');
                console.log($('#remove_file_' + whichrow));
                $('#remove_file_' + whichrow).prop('checked', true);
            });
        }
    },

    Select2Search: function () {
        $('.select-search select').select2({ width: '210px' });
    },
    Select2Add: function () {
        $('.select-add select').select2({
            minimumResultsForSearch: -1,
            width: '100%',
        });
    },
    SelectAdd: function () {
      $('.select-add .add-option').click(function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget),
                parent = $target.parent(),
                extra = prompt('Enter a new value'),
                select = $('select', parent),
                name = select.prop('name');
            if (extra != null) {
                select.append($('<option></option>').text(extra));
                select.val(extra).trigger('change');
                var hiddenField = $('<input type="hidden" class="add-fields" />')
                    .prop('name', 'add-options-' + name + '[]')
                    .prop('value', extra);
                select.after(hiddenField);
            }
            return false;
        });
    },
    CheckboxAdd: function () {
        $('.multiple-checkbox-add .add-checkbox').click(function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget),
                parent = $target.parent(),
                extra = prompt('Enter a new value'),
                checkboxes = $('.checkboxes', parent),
                first = $('input', checkboxes).first(),
                name = first.prop('name');
            if (extra != null) {
                extra = extra.replace(/\W+/g, ' ');
                var checkbox = $('<input type="checkbox" />');
                checkbox.prop('value', extra);
                checkbox.prop('name', name);
                checkboxes.append(checkbox);
                checkboxes.append(' ' + extra + '<br />');
                var hiddenField = $('<input type="hidden" class="add-fields" />')
                    .prop('name', 'add-options-' + name + '[]')
                    .prop('value', extra);
                checkboxes.after(hiddenField);
            }
            return false;
        });
    },
    DeleteConfirm: function () {
        $('.delete-entity').click(function (e) {
            var $target = $(this).attr('data-entity'),
                check = confirm('Are you sure you want to delete this ' + entity + '?');
            if (check) {
                return true;
            } else {
                return false;
            }
        });
    },
    /***
     * This function is designed to give the user a sense for how a name will
     * be transformed into a machine readable identifier
     */
    IdField: function () {
        $('input.identifier').append('<div class="identifier-visible"></div>');
        $('input.identifier').change(function (e) {
            var $field = $(this);
            // get the next visible id field
            var visible = $field.next('.identifier-visible'),
                // get api path
                api = $field.attr('api'),
                site = $field.attr('site');
            $.get(api, function (data) {});
        });
    },
    DefaultReset: function () {
        // This function expects to be in a fieldset, and to find a field (or fields)
        // withthe class .default-value.  It itterates over those, looking for a property
        // called data-field.  It then takes the default value and puts it into the
        // data-field input it finds
        $('input.reset-field').click(function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget),
                parent = $target.parent(),
                element = false,
                defaultFields = $('.default-value', parent);

            var confirm = window.confirm('Are you sure you want to reset this data to the default?');
            if (confirm) {
                defaultFields.each(function (i, el) {
                    element = $(el);
                    var fieldId = element.attr('data-field'),
                        destination = $('#' + fieldId),
                        defaultValue = element.text();
                    destination.val(defaultValue);
                });
                $('.colorpicker input').spectrum('destroy');
                P3Portal.Fields.ColorPicker();
            } else {
            }
            return false;
        });
    },
    Collapsible: function () {
        var toggle = function (e) {
            e.preventDefault();

            var target = $(e.currentTarget),
                fieldset = target.parent().parent();
            $('.fieldset-content', fieldset).slideToggle(function () {
                fieldset.toggleClass('collapsed');
            });

            var toggle = $('.fieldset-toggle', fieldset);
            if (toggle.hasClass('fa-chevron-circle-down')) {
                toggle.removeClass('fa-chevron-circle-down');
                toggle.addClass('fa-chevron-circle-up');
            } else {
                toggle.removeClass('fa-chevron-circle-up');
                toggle.addClass('fa-chevron-circle-down');
            }
            return false;
        };
        $('fieldset.collapsible legend').click(function (e) {
            toggle(e);
        });
        $('fieldset.collapsible .fieldset-description').click(function (e) {
            toggle(e);
        });
        $('fieldset.collapsible .fieldset-toggle').click(function (e) {
            toggle(e);
        });
    },

    TimeZone: function () {
        // get timezone for browser
        var $target = $('.timezone select');
        if ($target.length > 0) {
            var offset = new Date().getTimezoneOffset();
            var value = $target.val();
            if (value == 'none') {
                // No value has been set, so lets try to default it to the the user setting
                var timezone = $('option[value=' + offset + ']', $target).val();
                if (timezone) {
                    $target.val(timezone).trigger('change');
                } else {
                    $target.val('America/New_York').trigger('change');
                }
            }
        }
    },

    ImageUpload: function () {
        if ($('.image-upload').length > 0) {
            // Remove an image
            $('.remove').click(function (e) {
                var $e = $(e.currentTarget),
                    $el = $e.parent();
                $e.hide();
                $('.placeholder', $el).show();
                $('.hidden-remove', $el).val('1');
                $('img', $el).remove();
            });
            // Upload change
            $('input[type="file"]').change(function (e) {
                var target = $(e.currentTarget),
                    parent = target.prev(),
                    $el = parent;
                input = target[0];

                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        if (target.hasClass('upload')) {
                            P3Portal.upload(e.target.files[0], target.parent());
                        }
                        $('img', parent).remove();
                        var item = $('<img>').attr('src', e.target.result);

                        parent.append(item);
                        $('.placeholder', $el).hide();
                        $('.remove', $el).show();
                        $('.hidden-remove', $el).val('0');
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            });
        }
    },

    ColorPicker: function () {
        $('.colorpicker input').spectrum({
            preferredFormat: 'hex',
            showInput: true,
            showInitial: true,
            showPalette: true,
            palette: [['white', 'black', 'red', 'blue', 'green', 'yellow']],
        });
    },
    Validate: function () {
      if ($('form.validate') > 0) {
            $('form.validate')
                .parsley()
                .on('field:validated', function () {
                    var ok = $('.parsley-error').length === 0;
                    $('.bs-callout-warning').toggleClass('hide', ok);
                })
                .on('form:submit', function () {
                    console.log('submitting');
                });
        }

        $("#select_other .form-values").each(function () {
          var $this = $(this);

          if ($this.length) {
            var selText = $this.text();
            console.log(selText);
          }
        });

          window.Parsley.addValidator('testOtherSelector', function (value, requirements) {
            if (requirements[1] == $(requirements[0]).val() && '' == value) {
              return false;
            }else{
              return true;
            }
          }, 32)
          .addMessage('en', 'conditionalvalue', 'You have to insert some value');
    },
    FieldCloner: function () {
        var removeField = function ($el) {
            var wrapper = $el.parent().parent();
            $el.parent().remove();
            var i = 0;
            $('.clone-field', wrapper).each(function (i, el) {
                var element = $(el);
                var name = $('input', element).attr('name');
                var split = name.split('_'),
                    last = split[split.length - 1];
                name = name.replace('_' + parseInt(last), '_' + i);
                console.log(name);
                $('input', element).attr('name', name);
                $('input', element).attr('data-count', i);
                $('.remove-field', element).attr('data-count', i);
                i++;
            });
        };
        $('.multiple-text-field .remove-field').click(function (event) {
            removeField($(this));
        });

        $('.multiple-text-field button.add-field').click(function (e) {
            e.preventDefault();
            var parent = $(e.currentTarget).parent(),
                field = $('.clone-field', parent),
                last = field.length - 1,
                html = field[0].outerHTML,
                newfield = $(html);

            var count = $('input', field).attr('data-count'),
                name = $('input', field).attr('name'),
                i = last + 1;

            name = name.replace('_' + parseInt(count), '_' + i);
            $('input', newfield).attr('data-count', i);
            $('input', newfield).attr('name', name);
            $('input', newfield).attr('required', false);
            $('input', newfield).attr('value', '');
            $('.clone-field-list', parent).append(newfield);
            $('input', newfield).focus();
            $('.remove-field', newfield).remove();
            var remove = $('<span class="fa fa-close remove-field" data-count="' + i + '"></span>');
            remove.click(function (event) {
                removeField($(this));
            });
            newfield.append(remove);
            return false;
        });
    },
};
P3Portal.upload = function (name, file, scope) {
    P3Portal.Events.trigger('upload.start', { id: name });
    $.ajax({
        url: '/admin/api/upload',
        data: {
            uploadfilename: encodeURIComponent(name),
            file: file,
        },
        type: 'post',
        cache: false,
        xhr: function () {
            var xhr = new window.XMLHttpRequest();
            //Upload progress
            xhr.upload.addEventListener(
                'progress',
                function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = Math.floor((evt.loaded / evt.total) * 100);
                        //Do something with upload progress
                        P3Portal.Events.trigger('upload.progress', { id: name, percent: percentComplete });
                    }
                },
                false
            );
            return xhr;
        },
        success: function (event, message, response) {
            P3Portal.Events.trigger('upload.success', { id: name, data: event });
        },
    });
};
P3Portal.boot.push(P3Portal.Fields.ToggleFieldHelp);
P3Portal.boot.push(P3Portal.Fields.ContactValidation);
P3Portal.boot.push(P3Portal.Fields.UserRoleEdit);
P3Portal.boot.push(P3Portal.Fields.TabBind);
P3Portal.boot.push(P3Portal.Fields.UniqueUri);
P3Portal.boot.push(P3Portal.Fields.MobileTable);
P3Portal.boot.push(P3Portal.Fields.CustomerSearch);
P3Portal.boot.push(P3Portal.Fields.OverlayClick);
P3Portal.boot.push(P3Portal.Fields.DatePicker);
P3Portal.boot.push(P3Portal.Fields.DatetimePicker);
P3Portal.boot.push(P3Portal.Fields.SelectAdd);
P3Portal.boot.push(P3Portal.Fields.CheckboxAdd);
P3Portal.boot.push(P3Portal.Fields.ColorPicker);
P3Portal.boot.push(P3Portal.Fields.FieldCloner);
P3Portal.boot.push(P3Portal.Fields.Validate);
P3Portal.boot.push(P3Portal.Fields.Collapsible);
P3Portal.boot.push(P3Portal.Fields.DefaultReset);
P3Portal.boot.push(P3Portal.Fields.Select2);
P3Portal.boot.push(P3Portal.Fields.FileBehavior);
P3Portal.boot.push(P3Portal.Fields.Select2Add);
P3Portal.boot.push(P3Portal.Fields.Select2Search);
P3Portal.boot.push(P3Portal.Fields.TimeZone);
P3Portal.boot.push(P3Portal.Fields.ImageUpload);
P3Portal.boot.push(P3Portal.Fields.RemoveableFile);
P3Portal.boot.push(P3Portal.Fields.DeleteConfirm);
P3Portal.boot.push(P3Portal.Fields.LeaveForm);
P3Portal.boot.push(P3Portal.Fields.SalesRep);
